module.exports = __webpack_public_path__ + "static/img/zhuce_ic_zj@2x.ffc5e6e4.png";